import { useState } from 'react';

export function ResendCode({ email, name, password, setVerificationToken }) {
    const [isCodeSent, setIsCodeSent] = useState(false);
    const [isCodeSending, setIsCodeSending] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);

    const requestEmailVerificationCode = async () => {
        if(process.env.REACT_APP_PRESENTATION_MODE) return

        try {
            setIsCodeSending(true)
            const response = await fetch(`${process.env.REACT_APP_API_BASE}/auth/send-verification-code`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: 'include',
                body: JSON.stringify({
                    email,
                    name,
                    password
                })
            })
            const data = await response.json();
            
            if (!data || typeof data !== 'object' || !data.verificationToken) {
                return;
            }

            if (response.ok) {
                setVerificationToken(data.verificationToken)
                setIsCodeSending(false)
                setIsCodeSent(true);
            }
        } catch (error) {

        } finally {
            setIsCodeSending(false)
        }
    }

    const handleResendClick = async () => {
        if (isAnimating) return; // Prevent multiple clicks during animation

        setIsAnimating(true);
        setIsCodeSent(true);
        await requestEmailVerificationCode()
        // setIsCodeSent(true);

        // Reset after 3 seconds
        setTimeout(() => {
            setIsCodeSent(false);
            setTimeout(() => {
                setIsAnimating(false);
            }, 300); // Wait for fade-in animation to complete
        }, 10000);
    };

    return (

        <div className="relative h-10 w-full overflow-hidden flex flex-col items-center justify-center">
            {/* Original message */}
            <div
                className={`absolute inset-0 transition-all duration-300 ease-in-out
    flex flex-col items-center justify-center
    ${isCodeSent
                        ? 'opacity-0 -translate-y-2 pointer-events-none'
                        : 'opacity-100 translate-y-0 pointer-events-auto'
                    }`}
            >

                <span className="text-sm text-base-text/90 font-light">
                    コードが届きませんか？{' '}
                    <button
                        onClick={handleResendClick}
                        disabled={isAnimating}
                        className="text-base-text hover:text-[#9FA9CC] underline font-light transition-colors duration-200 disabled:opacity-50 z-20"
                    >
                        再送信
                    </button>
                </span>
            </div>

            {/* Success message */}
            <div
                className={`absolute inset-0 transition-all duration-300 ease-in-out
    flex flex-col items-center justify-center
    ${isCodeSent
                        ? 'opacity-100 translate-y-0 pointer-events-auto'
                        : 'opacity-0 translate-y-4 pointer-events-none'
                    }`}
            >

                <span className="flex w-full items-center gap-2 text-[#A2AAC7] text-tiny w-max rounded-md bg-[#A2AAC7]/15 py-1 px-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-mail-check-icon lucide-mail-check text-[#A2AAC7]"><path d="M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8" /><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" /><path d="m16 19 2 2 4-4" /></svg>
                    {/* new code was sent */}
                    新しいコードを送信しました
                </span>
            </div>
        </div>
    );
}